import React from 'react';
import styles from './Section.module.css';

const coinData = [
  { currency: 'BTC', accuracyLimit: '0.000000001' },
  { currency: 'NANO', accuracyLimit: '0.000000001' },
  { currency: 'NND', accuracyLimit: '0.000001' },
  { currency: 'ETH', accuracyLimit: '0.000000001' },
  { currency: 'USDT', accuracyLimit: '0.000001' },
  { currency: 'TRX', accuracyLimit: '0.000001' },
  { currency: 'DOGE', accuracyLimit: '0.00000001' },
  { currency: 'LTC', accuracyLimit: '0.00000001' },
  { currency: 'BNB', accuracyLimit: '0.000000001' },
  { currency: 'NNL', accuracyLimit: '0.000001' },
  { currency: 'BANANO', accuracyLimit: '0.000000001' },
  { currency: 'CUB', accuracyLimit: '0.000000001' },
];

const CoinAccuracyLimit = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionTitle}>Coin accuracy limit</div>
      <div className={styles.sectionContent}>
        <p>Due to the limitation of data storage accuracy, changes in the amount less than a certain amount will not take effect. The minimum accuracy of most coins is consistent with the currency accuracy of the blockchain. For example, the minimum unit of SATS is 1. The minimum data storage accuracy of each coin is shown in the following table:</p>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.tableHeader}>Currency</th>
            <th className={styles.tableHeader}>Accuracy Limit</th>
          </tr>
        </thead>
        <tbody>
          {coinData.map((coin) => (
            <tr key={coin.currency} className={styles.tableRow}>
              <td className={styles.tableCell}>{coin.currency}</td>
              <td className={styles.tableCell}>{coin.accuracyLimit}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CoinAccuracyLimit;
